import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';

/* Which emails you get. Everything starts on — an introduction nobody sees is
   an introduction that never happens — and each kind can be switched off. */

export default function NotificationSettings({ notify }) {
  const [data, setData] = useState(null);
  const [testing, setTesting] = useState(false);

  useEffect(() => {
    api.emailPrefs().then(setData).catch(() => {});
  }, []);

  if (!data) return null;

  async function toggle(kind, on) {
    const prev = data;
    setData({ ...data, prefs: { ...data.prefs, [kind]: on } });
    try {
      setData(await api.setEmailPrefs({ [kind]: on }));
      notify?.('Saved');
    } catch (err) {
      setData(prev);
      notify?.(err.message);
    }
  }

  async function sendTest() {
    setTesting(true);
    try {
      const r = await api.sendTestEmail();
      notify?.(`Test email sent to ${r.to} — check your inbox (and spam)`);
    } catch (err) {
      notify?.(err.message);
    } finally {
      setTesting(false);
    }
  }

  return (
    <div className="notif-settings">
      <p className="muted-sm">Sent to <b>{data.email}</b>.</p>
      {Object.entries(data.labels).map(([kind, label]) => (
        <label className="notif-row" key={kind}>
          <input type="checkbox" checked={Boolean(data.prefs[kind])}
            onChange={(e) => toggle(kind, e.target.checked)} />
          <span>{label}</span>
        </label>
      ))}
      <div>
        <button className="btn ghost sm" onClick={sendTest} disabled={testing}>
          {testing ? 'Sending…' : 'Send me a test email'}
        </button>
      </div>
    </div>
  );
}
